import React from 'react';
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';
import swal from 'sweetalert';

var version_info = JSON.parse(sessionStorage.getItem('version_info'));
class CSV_Workflow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            raw_data: this.props.node,
            filter_data: [],
            isError: false,
            save: false
        }
    }
    componentDidMount() {
        this.formatdata()
    }
    formatdata = () => {
        let FilteredData = [];
        if (this.state.raw_data.length == 0) {
            return
        }
        let keys = Object.keys(this.state.raw_data[0])
        if (
            keys.includes("TASK_NO") &&
            keys.includes("STEP_OR_QUESTION") &&
            keys.includes("CORRECT") &&
            keys.includes("ALTERNATIVE_1") &&
            keys.includes("ALTERNATIVE_2") &&
            keys.includes("ALTERNATIVE_3") &&
            keys.includes("MAX_RANGE") &&
            keys.includes("MIN_RANGE") &&
            keys.includes("TASK_TYPE") &&
            keys.includes("SUB_TASK_NO")
        ) {
            this.state.raw_data.map((list, index) => {

             
                if (list.SUB_TASK_NO != "" &&
                    list.TASK_TYPE != ""
                ) {
                    let filterSubTaskNo = list.SUB_TASK_NO.split(".");
                    if (filterSubTaskNo.length == 1) {
                        list.ERROR = false
                        if ((list.TASK_TYPE).toLowerCase() == "m") {

                            if (list.ALTERNATIVE_2 != '' || list.ALTERNATIVE_3 != '') {
                                list.MCQ_TYPE = 4
                            } else {
                                list.MCQ_TYPE = 2
                            }
                            if (list.STEP_OR_QUESTION == '') {
                                list.ERROR = true
                                this.setState({ isError: true })
                            }
                            FilteredData.push(list)
                        }
                        if ((list.TASK_TYPE).toLowerCase() == "r") {
                            if (Number(list.MIN_RANGE) == NaN || Number(list.MAX_RANGE) == NaN) {
                                list.ERROR = true
                                this.setState({ isError: true })

                            }

                            if (Number(list.MIN_RANGE) > Number(list.MAX_RANGE)) {
                                list.ERROR = true
                                this.setState({ isError: true })

                            }
                            if (list.STEP_OR_QUESTION == '') {
                                list.ERROR = true
                                this.setState({ isError: true })
                            }

                            FilteredData.push(
                                Object.assign(list)
                            )
                        }
                        if ((list.TASK_TYPE).toLowerCase() == "p") {

                            // if (list.CHILD.length == 0) {
                            //     list.ERROR = true
                            //     // this.setState({ isError: true })
                            // }
                            if (list.STEP_OR_QUESTION == '') {
                                list.ERROR = true
                                this.setState({ isError: true })
                            }
                            FilteredData.push(
                                Object.assign(
                                    list,
                                    {
                                        CHILD: []
                                    })
                            )
                        }
                    }
                    else {
                        let findObjIndex = FilteredData.findIndex(raw => raw.TASK_NO == filterSubTaskNo[0])
                        if (findObjIndex != -1) {
                            this.alignChilds(list, filterSubTaskNo, 0, FilteredData);
                        }
                        else {
                            // return
                        }
                    }
                } else {
                  
                    return
                }
                if (this.state.raw_data.length - 1 == index) {
                    this.setState({ filter_data: FilteredData })
                }
            })
        } else {
            this.props.CloseCsv()
            swal("Invalid csv format.", "", "warning")
        }

    }
    alignChilds = (list_obj, filterSubTaskNo, indexing, push_obj) => {
        let PopObj = JSON.parse(JSON.stringify(filterSubTaskNo));
        PopObj.splice(indexing + 1);
        let index = push_obj.findIndex(raw => raw.SUB_TASK_NO == PopObj.join('.'))

        if (filterSubTaskNo.length - 2 == indexing) {
            if (index == -1) {
                return
            }
            if (push_obj[index].CHILD) {
                list_obj.ERROR = false
                if ((list_obj.TASK_TYPE).toLowerCase() == "m") {
                    if (list_obj.ALTERNATIVE_2 != '' || list_obj.ALTERNATIVE_3 != '') {
                        list_obj.MCQ_TYPE = 4
                    } else {
                        list_obj.MCQ_TYPE = 2
                    }
                    if (list_obj.STEP_OR_QUESTION == '') {
                        this.setState({ isError: true })
                        list_obj.ERROR = true
                    }
                }
                else if ((list_obj.TASK_TYPE).toLowerCase() == "r") {
                    if (Number(list_obj.MIN_RANGE) == NaN || Number(list_obj.MAX_RANGE) == NaN) {
                        list_obj.ERROR = true
                        this.setState({ isError: true })

                    }
                    if (Number(list_obj.MIN_RANGE) > Number(list_obj.MAX_RANGE)) {
                        list_obj.ERROR = true
                        this.setState({ isError: true })

                    }
                    if (list_obj.STEP_OR_QUESTION == '') {
                        list_obj.ERROR = true
                        this.setState({ isError: true })
                    }
                }
                else if ((list_obj.TASK_TYPE).toLowerCase() == "p") {
                    // if (list_obj.CHILD.length == 0) {
                    //     list_obj.ERROR = true
                    //     this.setState({ isError: true })

                    // }
                    if (list_obj.STEP_OR_QUESTION == '') {
                        list_obj.ERROR = true
                        this.setState({ isError: true })
                    }

                }
                if ((push_obj[index].TASK_TYPE).toLowerCase() == "p") {
                    push_obj[index].CHILD.push(
                        Object.assign(
                            list_obj,
                            {
                                CHILD: []
                            })
                    )
                }
            }
            return
        } else {

            if (push_obj[index]) {
                this.alignChilds(list_obj, filterSubTaskNo, indexing + 1, push_obj[index].CHILD)
            }
        }
    }
    input_change = (e, node, option) => {
        // this.setState({ save: false })
        this.state.raw_data.find(x => (x.id == node.id) ? x[option] = e.target.value : null)
        this.setState({ ...this.state, save: false }, () => this.formatdata())
    }
    delete_task = (node) => {
        this.setState({ save: false })
        let raw_temp = this.state.raw_data.filter(x => x.id != node.id)
        this.setState({ raw_data: raw_temp, save: false }, () => this.formatdata())
    }
    varify_csv = () => {
        if (this.state.filter_data.length > 0) {
            this.setState({ isError: false, save: true })
            this.state.filter_data.map((list, index) => {
                this.varify_csv_childs(list)
            })
        }
    }
    varify_csv_childs = (list) => { 
        if ((list.TASK_TYPE).toLowerCase() == "m") {
            if (list.ERROR == true) {
                this.setState({ isError: true })
                return
            }
        }
        else if ((list.TASK_TYPE).toLowerCase() == "r") {
            if (list.ERROR == true) {
                this.setState({ isError: true })
                return
            }
        }
        else if ((list.TASK_TYPE).toLowerCase() == "p") {
            if (list.CHILD.length == 0) {
                list.ERROR = true
                this.setState({ isError: true })
                return
            } if (list.ERROR == true) {
                this.setState({ isError: true })
                return
            }

            list.CHILD.map((li, ind) => {
                this.varify_csv_childs(li)
            })
        }
    }
    save_csv = () => {
        if (this.state.save && this.state.isError == false) {

            var _this = this;

            var data = {
                sid: ud.main_id,
                workflow_id: sessionStorage.getItem("selected_workflow"),
                version_id: version_info.id,
                mcq_type: 1,
                CSV_data: this.state.filter_data
            }
            let headers = {
                'user_id': (ud.id).toString(),
                'session_id': (ud.session_id).toString(),
                'user_type': (ud.usertype).toString(),
                'main_id': (ud.main_id).toString(),
                'jwt_token': (jwt),
                'c_id': (ud.c_id).toString()
            }
            axios.post(`${SERVER_IP}/workflowUploadCSVAPI`, data, { withCredentials: true, headers: headers })
                .then(function (response) {

                    if (response.status === 200) {
                        if (response.data.error === false) {
                            swal(response.data.message, "", "success");
                            _this.setState({ load_5_sec: true })
                            setTimeout(() => _this.props.CloseCsv(true), 5000)
                            return
                        }else{
                            auth_response_flow(response.data, (return_response) => {
                                if (return_response.error === false && return_response.retry === true) {
                                    _this.save_csv();
                                }
                            })
                        }
                        // swal(response.data.message, "", "warning");
                    }
                })
                .catch(function (error) {
                    swal("Something Went Wrong. Please Retry.", "", "warning")
                });
        }
    }
    render() {

        return (
            <div id="popup" className="overlay">
                <div className="popup" style={{ margin: '5% auto', width: '90%' }}>
                    <div className="content">
                        <div className="card m-b-30" >
                            <div className="card-header bg-white heading-cont">
                                <div className="d-flex align-content-center justify-content-between">
                                    <h5 className="card-title text-black">Verify CSV</h5>
                                    {this.state.save && this.state.isError == false ?
                                        <button onClick={this.save_csv} className="btn btn-success mr-3">Upload</button>
                                        :
                                        <button onClick={this.varify_csv} className="btn btn-primary mr-3">Submit</button>
                                    }
                                </div>

                                <div onClick={() => this.props.CloseCsv(false)}>
                                    <svg className="bi bi-x-circle-fill" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-4.146-3.146a.5.5 0 00-.708-.708L8 7.293 4.854 4.146a.5.5 0 10-.708.708L7.293 8l-3.147 3.146a.5.5 0 00.708.708L8 8.707l3.146 3.147a.5.5 0 00.708-.708L8.707 8l3.147-3.146z" clip-rule="evenodd" />
                                    </svg>
                                </div>
                            </div>
                            <div className="card-body" style={popUp}>
                                {this.state.filter_data.map((list, index) =>
                                    <TaskTree node={list} input_change={this.input_change} delete_task={this.delete_task} />
                                )}
                                {this.state.filter_data.length == 0 ?
                                    <h5 className="text-black">No Data Found.</h5>
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.load_5_sec ?
                    <div id="loader" class="loaderBar loader-bar is-active" data-text=""></div>
                    : null}
            </div>
        )
    }
}


export default CSV_Workflow


class TaskTree extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {

    }
    render() {
        return (
            <>
                <div className="form-content uploadcsvdesign">
                    <div border5x="rdius5">
                        {this.props.node.TASK_TYPE == "M" ?
                            <div className="card mt-2 ml-3 mr-3 mb-2" id="in-q1">
                                <div style={{ background: this.props.node.ERROR ? "#2f3a796d" : "", borderRadius:'.5rem', padding:'.5rem' }} className="mb-0 text-dark">
                                    <div className="w-100">
                                        <ul className="CSV_Workflow g1">
                                            <li>
                                                <p className="text-dark mb-0 p-2"><span className="fa fa-th-list"></span> </p>
                                            </li>
                                            <li><p className="m-0">Question</p>
                                                <input className="form_control w-100" value={this.props.node.STEP_OR_QUESTION} type="text" onChange={(e) => this.props.input_change(e, this.props.node, "STEP_OR_QUESTION")} />
                                            </li>

                                            <li>
                                                <span onClick={() => this.props.delete_task(this.props.node)} className="fa fa-close"></span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="w-100 ml-4">
                                        <ul className="CSV_Workflow_option">
                                            <li>
                                                <p className="m-0">Option 1</p>
                                                <input className="form_control" value={this.props.node.CORRECT} type="text" onChange={(e) => this.props.input_change(e, this.props.node, "CORRECT")} />
                                            </li>
                                            <li>
                                                <p className="m-0">Option 2</p>
                                                <input className="form_control" value={this.props.node.ALTERNATIVE_1} type="text" onChange={(e) => this.props.input_change(e, this.props.node, "ALTERNATIVE_1")} />
                                            </li>
                                            <li>
                                                <p className="m-0">Option 3</p>
                                                <input className="form_control" value={this.props.node.ALTERNATIVE_2} type="text" onChange={(e) => this.props.input_change(e, this.props.node, "ALTERNATIVE_2")} />
                                            </li>
                                            <li>
                                                <p className="m-0">Option 4</p>
                                                <input className="form_control" value={this.props.node.ALTERNATIVE_3} type="text" onChange={(e) => this.props.input_change(e, this.props.node, "ALTERNATIVE_3")} />
                                            </li>
                                        </ul>
                                    </div>

                                    <div>
                                    </div>
                                </div>
                            </div>
                            : null}
                        {this.props.node.TASK_TYPE == "R" ?
                            <div className="card mt-2 ml-3 mr-3 mb-2" id="in-q1">
                                <div style={{ background: this.props.node.ERROR ? "#2f3a796d" : "", borderRadius:'.5rem', padding:'.5rem' }} className="mb-0 text-dark">
                                    <div className="w-100">
                                        <ul className="CSV_Workflow g1">
                                            <li>
                                                <p className="text-dark mb-0 p-2"><span className="fa fa-sort-numeric-asc"></span> </p>
                                            </li>
                                            <li><p className="m-0">Question</p>
                                                <input className="form_control w-100" value={this.props.node.STEP_OR_QUESTION} type="text" onChange={(e) => this.props.input_change(e, this.props.node, "STEP_OR_QUESTION")} />
                                            </li>

                                            <li>
                                                <span onClick={() => this.props.delete_task(this.props.node)} className="fa fa-close"></span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="w-100 ml-4">
                                        <ul className="CSV_Workflow_option">
                                            <li>
                                                <p className="m-0">Min Range</p>
                                                <input className="form_control" value={this.props.node.MIN_RANGE} type="number" onChange={(e) => this.props.input_change(e, this.props.node, "MIN_RANGE")} />
                                            </li>
                                            <li>
                                                <p className="m-0">Max Range</p>
                                                <input className="form_control" value={this.props.node.MAX_RANGE} type="number" onChange={(e) => this.props.input_change(e, this.props.node, "MAX_RANGE")} />
                                            </li>
                                        </ul>
                                    </div>

                                    <div>
                                    </div>
                                </div>
                            </div>


                            : null}
                        {this.props.node.TASK_TYPE == "P" ?
                            <div className="card mt-2 ml-3 mr-3 mb-2" id="in-q1">
                                <div style={{ background: this.props.node.ERROR ? "#2f3a796d" : "", borderRadius:'.5rem', padding:'.5rem' }} className="mb-0 text-dark space-between">
                                    <div className="w-100">
                                        <ul className="CSV_Workflow g1">
                                            <li>
                                                <p className="text-dark mb-0 p-2"><span className="fa fa-sitemap"></span> </p>
                                            </li>

                                            <li>
                                                <input className="form_control w-100" value={this.props.node.STEP_OR_QUESTION} type="text" onChange={(e) => this.props.input_change(e, this.props.node, "STEP_OR_QUESTION")} />
                                            </li>

                                            <li>
                                                <span onClick={() => this.props.delete_task(this.props.node)} className="fa fa-close"></span>
                                            </li>
                                        </ul>

                                    </div>
                                    {this.props.node.CHILD ? this.props.node.CHILD.length > 0 ? this.props.node.CHILD.map((li, ind) => <TaskTree node={li} input_change={this.props.input_change} delete_task={this.props.delete_task} />) : null : null}

                                </div>
                            </div>

                            : null}
                    </div>
                </div>
            </ >

        )
    }
}


const popUp = {
    width: '100%',
    height: '75vh',
    overflowY: 'scroll'
}